import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { OAuth } from '../models/oauth';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OAuthService {
  private oauthCache: OAuth[] = [];

  constructor(public http: HttpClient) { }

  getOAuths(): Observable<OAuth[]> {
    if (this.oauthCache.length > 0) {
      return of(this.oauthCache);
    }

    const url = `${environment.apiUrl}oauth`;
    return this.http.get<OAuth[]>(url).pipe(
      tap((oauths) => {
        this.oauthCache = oauths;
      })
    );
  }

  getOAuth(id: string): Observable<OAuth | undefined> {
    const oauth = this.oauthCache.find(o => o.id === id);
    if (oauth) {
      return of(oauth);
    }

    const url = `${environment.apiUrl}oauth/${id}`;
    return this.http.get<OAuth>(url);
  }

  getOAuthsByRosterId(rosterId: string): Observable<OAuth[]> {
    const url = `${environment.apiUrl}rosters/${rosterId}/oauth`;
    return this.http.get<OAuth[]>(url);
  }

  getDemographics(id: string): Observable<any> {
    const url = `${environment.apiUrl}oauth/${id}/demographics`;
    return this.http.get<any>(url);
  }

  getVideoAnalytics(id: string, videoId: string, startDate?: string, endDate?: string, forceRefresh?: boolean): Observable<any> {
    let url = `${environment.apiUrl}oauth/${id}/videos/${videoId}/analytics`;
    const params: string[] = [];
    if (startDate) { params.push(`startDate=${encodeURIComponent(startDate)}`); }
    if (endDate) { params.push(`endDate=${encodeURIComponent(endDate)}`); }
    if (forceRefresh) { params.push('forceRefresh=true'); }
    if (params.length) { url += '?' + params.join('&'); }
    return this.http.get<any>(url);
  }

  // Currently-live Instagram stories with per-frame insights. Stories cannot be looked up by
  // link, and both the stories and their insights are gone 24 hours after posting.
  getInstagramStories(id: string): Observable<any> {
    const url = `${environment.apiUrl}oauth/${id}/stories`;
    return this.http.get<any>(url);
  }

  disconnectOAuth(id: string): Observable<any> {
    const url = `${environment.apiUrl}oauth/${id}`;
    return this.http.delete(url);
  }

  clearCache(): void {
    this.oauthCache = [];
  }
}
